export default __webpack_public_path__ + "static/media/mobile_app.77b3bb5f.png";